<div class="p-grid table-demo ">
    <div class="p-col-12">
        <p-toast key="toastmsg"></p-toast>
        <div class="card">
            <h3>Skill History</h3>
            <section class="body-section">
                <div class=" container-fluid p-p-0">
                    <main>
                        <div class="col-md-12 user-top-body-header d-flex justify-content-between">
                            <div class="right-side-section">
                                <div class="box spending-box">
                                    <div class="pie-chart">
                                        <!-- <p-chart type="doughnut" [data]="data" [options]="options"></p-chart> -->
                                        <div class="overall-spending">
                                            <h4>skill
                                            </h4>
                                            <span>{{playerRating}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                       
                    </main>
                </div>
            </section>
        </div>

        <div class="card">
            <h3>Matches History</h3>
            <section class="body-section">
                <div class=" container-fluid p-p-0">
                    <main>
                        <div class="bottom-container Transaction-table MatchesHistory p-p-0  bg-white">
                            <div class="box transaction-box  p-p-0">
                               
                                <p-table class=" expandable" #dt [value]="matchList" [paginator]="true" [rows]="10" [lazy]="true"
                                    [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                                    (onLazyLoad)="loadMatches($event)" [loading]="loading" [rowsPerPageOptions]="paginationOption">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Name
                                                </div>
                                            </th>
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    My Skills
                                                </div>
                                            </th>
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Opponent
                                                </div>
                                            </th>
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Op. Skill
                
                                                </div>
                                            </th>
                                            <th class="tournament-head">
                                                <div class="p-d-flex p-jc-between p-ai-center ">
                                                    Tournaments
                
                
                                                </div>
                                            </th>
                                            <th class="tournament-result">
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Result
                
                                                </div>
                                            </th>
                
                                            <th>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    Date
                
                                                </div>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-match>
                                        <tr class="p-selectable-row">
                                            <td>
                                                {{this.item?.fullName}}
                                            </td>                                
                                            <td *ngIf="match?.opponents_data?.myRating?.showclass">
                                                
                                                    {{match?.opponents_data?.myRating?.winnerRating}}
                                                    {{match?.opponents_data?.myRating?.looserRating}}
                                                    <span *ngIf="match?.opponents_data?.myRating?.showclass" class="colorgreen">+
                                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}                                    
                                                    </span>                                        
                                                    <span *ngIf="!match?.opponents_data?.myRating?.showclass" class="colorred">
                                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}                                    
                                                    </span> 
                                            </td>
                                            <td *ngIf="!match?.opponents_data?.myRating?.showclass">
                                                
                                                    {{match?.opponents_data?.myRating?.winnerRating}}
                                                    {{match?.opponents_data?.myRating?.looserRating}}
                                                    <span *ngIf="match?.opponents_data?.myRating?.showclass" class="colorgreen">+
                                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}
                                                    </span>
                                                    <span *ngIf="!match?.opponents_data?.myRating?.showclass" class="colorred">
                                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}                                    
                                                    </span> 
                                            </td>
                                            <td>
                                                {{match?.opponents_data?.userData?.fullName}}
                                            </td>
                                            <td>
                                                {{match?.opponents_data?.opponentRating?.winnerRating}}
                                                {{match?.opponents_data?.opponentRating?.looserRating}}
                                            </td>
                                            <td class="tournament-head">
                                                {{match.opponents_data?.tournamentData[0]?.name}}
                                            </td>
                                            <td class="tournament-result">
                                                <span class="rin-type-label score">{{match.opponents_data?.player1val}}-{{match.opponents_data?.player2val}}</span>{{match?.opponents_data?.playerScore}} 
                                            </td>
                                            <td>
                                                {{match?.opponents_data?.tournamentData[0]?.startdate|date:'dd-MM-yyyy'}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="7">Match History not found.</td>
                                        </tr>
                                    </ng-template>
                
                                </p-table>
                            </div>
                        </div> 
                       
                    </main>
                </div>
            </section>
        </div>

        <div class="card">
            
            <section class="body-section">
                <div class=" container-fluid p-p-0">
                    <main>
                        <div class="bottom-container Transaction-table MatchesHistory p-p-0  bg-white">
                            <div class="box transaction-box  p-p-0">
                               
                                <div class="header-container">
                                    <h3 class="section-header">Skill History</h3>
                                </div>
                                <p-dropdown inputId="yearOptions" [ngModel]="selectedYear" [options]="yearOptions"
                                    (onChange)="onClickYear($event)" placeholder="Select year" optionLabel="year"
                                    [filter]="true"></p-dropdown>
                                <p-chart type="line" [data]="skillsData" [options]="basicOptions"></p-chart>
                            </div>
                        </div> 
                       
                    </main>
                </div>
            </section>
        </div>
      
   
    </div>
</div>
